<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
  >
    <InvoiceHeader invoice_type="add_boxes" v-if="isHide == true" />
    
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_boxes") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div
      class="px-6 py-4"
      v-if="
        $store.getters['checkUserAccess']({
          id: '14',
          action: 'add',
        })
      "
    >
      <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <div class="grid md:grid-cols-2 gap-6">
          <form @submit="addSaleItem">
            <BaseInput
              v-model="bo_name"
              :label="$t('add_boxes')"
              :placeholder="$t('add_boxes')"
              :rules="rules"
              :isError="checkRulesIsError(bo_name, 'add').isError"
              :errorMsg="checkRulesIsError(bo_name, 'add').errorMsg"
            />

            <ButtonInput
              type="button"
              @click="addSaleItem"
              :label="$t('add')"
              :isLoading="isBtnLoading"
            />
          </form>
        </div>
      </div>
    </div>
    <!-- Table Container -->
    <div class="px-6 py-4" v-if="
      $store.getters['checkUserAccess']({
        id: '14',
        action: 'view',
      })
    ">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.all_box.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
          
          <div class="flex items-center space-x-4">
            <button
              class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
              @click="printReportFunc"
              id="button_print"
              v-if="$store.getters['checkPrintAccess']"
            >
              <i class="fa-solid fa-print mr-2"></i>
              {{ $t("print") }}
            </button>
          </div>
        </div>
        <!--in ltr change (text-right to text-left)-->
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          :headers="headers"
          :items="filterItems"
          :loading="isLoadingData"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          alternating
          :buttons-pagination="true"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '14',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.bo_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '14',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
            <a
              class="mx-1 my-1"
              :href="'box-detail/' + item.bo_id"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '14',
                  action: 'detail',
                })
              "
            >
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a>
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">{{ $t('loading') }}...</p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>
          <template #item-bo_amount_dinar="item">
            {{ formatNumber(item.bo_amount_dinar) }}
          </template>
          <template #item-bo_amount_dollar="item">
            {{ formatNumber(item.bo_amount_dollar) }}
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
               <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
          </template>
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"></i>
              <p class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">{{ $t("no_data_found") }}</p>
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ $t("try_adjusting_your_search_criteria") }}</p>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.bo_name"
          :label="$t('add_boxes')"
          :placeholder="$t('add_boxes')"
          :rules="rules"
          :isError="checkRulesIsError(current.bo_name, 'edit').isError"
          :errorMsg="checkRulesIsError(current.bo_name, 'edit').errorMsg"
        />

        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import { formatNumber } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    InvoiceHeader,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      bo_name: "",
      placeholderText: this.$t("box_name"),
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      isHide: false,
    };
  },
  created() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "14",
        action: "view",
      })
    ) {
      this.getData();
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.all_box.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.all_box.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("all_box/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.all_box.isShowResultDialog;
    },
    items() {
      return this.$store.state.all_box.items;
    },
    filterItems() {
      return this.$store.getters["all_box/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.all_box.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.all_box.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.all_box.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "bo_id", sortable: true },
        { text: this.$t("box_name"), value: "bo_name", sortable: true },
        {
          text: this.$t("box_dinar_amount"),
          value: "bo_amount_dinar",
          sortable: true,
        },
        {
          text: this.$t("box_dollar_amount"),
          value: "bo_amount_dollar",
          sortable: true,
        },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit('all_box/SET_SEARCH', value);
    },
    printReportFunc() {
      this.isHide = true;
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }
        window.print();
      }, 100);
    },
    formatDate(date) {
      return formatDate(date);
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    getData() {
      this.$store.dispatch("all_box/getItems");
    },
    async addSaleItem(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.all_box.isBtnLoading) return;
      //check form validation
      this.isSubmited = true;
      if (this.checkRulesIsError(this.bo_name, "add").isError) {
        return;
      }
      this.$store.state.all_box.isBtnLoading = true;
      var res = await this.$store.dispatch("all_box/addNewItem", {
        bo_name: this.bo_name,
      });
      if (res.status == 200) {
        this.bo_name = "";
        this.$store.state.all_box.isBtnLoading = false;
        this.isSubmited = false;
      }
    },
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("all_box/REMOVE_ITEM", id);
        this.$store.dispatch("all_box/deleteItem", id);
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (this.checkRulesIsError(this.current.bo_name, "edit").isError) {
        return;
      }
      this.$store.state.all_box.isBtnEditLoading = true;
      var res = await this.$store.dispatch("all_box/editItem", {
        bo_id: this.current.bo_id,
        bo_name: this.current.bo_name,
      });

      this.isSubmitedEdit = false;
      this.$store.state.all_box.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
  },
};
</script>
